// §6 設定型別。所有顯示名稱都從這裡讀，不在元件裡寫死（§13.6）
// 站台的投入／產出定義（OP-4 以後為架構中，不列）
export const STATION_FLOW = [
    { stationId: 'OP1', inputMaterial: 'PANEL', outputs: ['JBOX', 'PANEL_NJ'] },
    { stationId: 'OP2', inputMaterial: 'PANEL_NJ', outputs: ['FRAME', 'GLAZED_LAM'] },
    { stationId: 'OP3', inputMaterial: 'GLAZED_LAM', outputs: ['GLASS', 'LAMINATE'] },
];
export const RESOLUTION_LABEL = {
    R1: '逐片實測',
    R2: '集合分攤',
    R3: '混合分攤',
    R4: '含無歸屬料',
};
export const RESOLUTION_HINT = {
    R1: '每片都有自己的實測重量，物料帳可直接對應到單片。',
    R2: '整批實測、按理論基準分攤到集合內每一片。每片完整歸屬於同一集合。',
    R3: '分攤跨越集合邊界（按重量切分），單片數字對不到實體。需個案核可。',
    R4: '批內含無法歸屬到面板的料（例如清機粉塵），分攤結果僅供參考。',
};
export const GRANULARITY_LABEL = {
    item: '整批秤',
    panel: '逐片秤',
};
//# sourceMappingURL=config.js.map